import { ComponentProps } from 'react';

import Box, { BoxStyleProps } from '../Box';

interface ImageProps extends ComponentProps<'img'>, BoxStyleProps {}

export default function Image(props: ImageProps): JSX.Element {
  return <Box as="img" {...props} />;
}
